// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Table } from '@/ui';
import { StyledContentBlock, StyledPageWrapper } from './GeneratedQrListStyles';
import { Pagination } from '@/components';
import { getGeneratedQRTableColumns } from './columns';

// Models
import { IGeneratedQrItem } from '@/models/generateQr.model';

type TGeneratedQrList = {
  qrList: IGeneratedQrItem[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
};

const GeneratedQrList = ({ qrList, currentPage, isLoading, total, onPageChange }: TGeneratedQrList) => {
  const { t } = useTranslation(['products']);

  return (
    <StyledPageWrapper>
      <StyledContentBlock>
        <Table columns={getGeneratedQRTableColumns({ t })} dataSource={qrList ?? []} rowKey="id" loading={isLoading} />
      </StyledContentBlock>
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledPageWrapper>
  );
};

export default GeneratedQrList;
